import { render, staticRenderFns } from "./VAB2.vue?vue&type=template&id=693358ec&"
import script from "./VAB2.vue?vue&type=script&lang=js&"
export * from "./VAB2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports